<!-- eslint-disable max-lines -->
<template>
  <div :class="['widget', {'border-error': error}]">
    <v-container>
      <v-layout>
        <span class="subheading">Build information</span>
      </v-layout>

      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <v-layout
            align-center
            justify-space-between
            style="height: 36px;">
            <span class="body-2">Installation</span>
            <span v-if="[0, 1, 2, 3].indexOf(site.stationInstallation) > -1">
              {{ site.stationInstallation | formatInstallation }}
            </span>
            <span v-else>
              <span class="grey--text">unknown</span>
            </span>
          </v-layout>
          <v-divider/>
          <v-layout
            align-center
            justify-space-between
            style="height: 36px;">
            <span class="body-2">Mount type</span>
            <span v-if="site.mountType">
              {{ site.mountType }}
            </span>
            <span v-else>
              <span class="grey--text">unknown</span>
            </span>
          </v-layout>
          <v-divider/>
          <v-layout
            align-center
            justify-space-between
            style="height: 36px;">
            <span class="body-2">Primary backhaul</span>
            <span v-if="site.connectionType === 0">
              router
            </span>
            <span v-else-if="site.connectionType === 3">
              LAN
            </span>
            <span v-else>
              <span class="grey--text">unknown</span>
            </span>
          </v-layout>
          <v-divider/>
          <v-layout
            align-center
            justify-space-between>
            <v-flex grow>
              <span class="body-2">LNA serials</span>
            </v-flex>
            <v-flex shrink>
              <v-btn
                v-if="expandLNASerial === 0"
                class="ma-0"
                icon
                @click="expandLNASerial = -1">
                <v-icon>expand_less</v-icon>
              </v-btn>
              <v-btn
                v-else
                :disabled="site.lnaSerials.length === 0"
                class="ma-0"
                icon
                @click="expandLNASerial = 0">
                <v-icon>expand_more</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-expansion-panel
              v-if="site.lnaSerials.length > 0"
              :value="expandLNASerial"
              style="box-shadow: none;">
              <v-expansion-panel-content
                style="background-color: initial;
                       padding-left: 20px;">
                <table
                  class="mb-1"
                  style="width: 100%; table-layout: fixed;">
                  <tr>
                    <td class="body-2 grey--text">Submission date</td>
                    <td class="body-2 grey--text">LNA serial</td>
                  </tr>
                  <tr
                    v-for="({lnaSerial,submissionDate},index)
                    in site.lnaSerials"
                    :key="lnaSerial">
                    <template v-if="index > 0">
                      <td class="grey--text text--darken-1">
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td class="grey--text text--darken-1">
                        {{ lnaSerial | formatLNASerial }}
                      </td>
                    </template>
                    <template v-else>
                      <td>
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td>
                        {{ lnaSerial | formatLNASerial }}
                      </td>
                    </template>
                  </tr>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-layout>
          <v-divider/>
          <v-layout
            align-center
            justify-space-between>
            <v-flex grow>
              <span class="body-2">Base station serials</span>
            </v-flex>
            <v-flex shrink>
              <v-btn
                v-if="expandBsSerial === 0"
                class="ma-0"
                icon
                @click="expandBsSerial = -1">
                <v-icon>expand_less</v-icon>
              </v-btn>
              <v-btn
                v-else
                :disabled="site.bsSerials.length === 0"
                class="ma-0"
                icon
                @click="expandBsSerial = 0">
                <v-icon>expand_more</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-expansion-panel
              v-if="site.bsSerials.length > 0"
              :value="expandBsSerial"
              style="box-shadow: none;">
              <v-expansion-panel-content
                style="background-color: initial;
                       padding-left: 20px;">
                <table
                  class="mb-1"
                  style="width: 100%; table-layout: fixed;">
                  <tr>
                    <td class="body-2 grey--text">Submission date</td>
                    <td class="body-2 grey--text">Base station serial</td>
                  </tr>
                  <tr
                    v-for="({bsSerial,submissionDate},index) in site.bsSerials"
                    :key="bsSerial">
                    <template v-if="index > 0">
                      <td class="grey--text text--darken-1">
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td class="grey--text text--darken-1">
                        {{ bsSerial | formatBsSerial }}
                      </td>
                    </template>
                    <template v-else>
                      <td>
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td>
                        {{ bsSerial | formatBsSerial }}
                      </td>
                    </template>
                  </tr>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-layout>
          <v-divider/>
          <v-layout
            align-center
            justify-space-between>
            <v-flex grow>
              <span class="body-2">USB serials</span>
            </v-flex>
            <v-flex shrink>
              <v-btn
                v-if="expandUSBSerial === 0"
                class="ma-0"
                icon
                @click="expandUSBSerial = -1">
                <v-icon>expand_less</v-icon>
              </v-btn>
              <v-btn
                v-else
                :disabled="site.usbSerials.length === 0"
                class="ma-0"
                icon
                @click="expandUSBSerial = 0">
                <v-icon>expand_more</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-expansion-panel
              v-if="site.usbSerials.length > 0"
              :value="expandUSBSerial"
              style="box-shadow: none;">
              <v-expansion-panel-content
                style="background-color: initial;
                       padding-left: 20px;">
                <table
                  class="mb-1"
                  style="width: 100%; table-layout: fixed;">
                  <tr>
                    <td class="body-2 grey--text">Submission date</td>
                    <td class="body-2 grey--text">USB serial</td>
                  </tr>
                  <tr
                    v-for="({usbSerial,submissionDate},index)
                    in site.usbSerials"
                    :key="usbSerial">
                    <template v-if="index > 0">
                      <td class="grey--text text--darken-1">
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td class="grey--text text--darken-1">
                        {{ usbSerial | formatUSBSerial }}
                      </td>
                    </template>
                    <template v-else>
                      <td>
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td>
                        {{ usbSerial | formatUSBSerial }}
                      </td>
                    </template>
                  </tr>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-layout>
          <v-divider/>
          <v-layout
            align-center
            justify-space-between>
            <v-flex grow>
              <span class="body-2">Router serials</span>
            </v-flex>
            <v-flex shrink>
              <v-btn
                v-if="expandRouterSerial === 0"
                class="ma-0"
                icon
                @click="expandRouterSerial = -1">
                <v-icon>expand_less</v-icon>
              </v-btn>
              <v-btn
                v-else
                :disabled="site.routerSerials.length === 0"
                class="ma-0"
                icon
                @click="expandRouterSerial = 0">
                <v-icon>expand_more</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-expansion-panel
              v-if="site.routerSerials.length > 0"
              :value="expandRouterSerial"
              style="box-shadow: none;">
              <v-expansion-panel-content
                style="background-color: initial;
                       padding-left: 20px;">
                <table
                  class="mb-1"
                  style="width: 100%; table-layout: fixed;">
                  <tr>
                    <td class="body-2 grey--text">Submission date</td>
                    <td class="body-2 grey--text">Router serial</td>
                  </tr>
                  <tr
                    v-for="({routerSerial,submissionDate},index)
                    in site.routerSerials"
                    :key="routerSerial">
                    <template v-if="index > 0">
                      <td class="grey--text text--darken-1">
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td class="grey--text text--darken-1">
                        {{ routerSerial }}
                      </td>
                    </template>
                    <template v-else>
                      <td>
                        {{ submissionDate | formatLLL }}
                      </td>
                      <td>
                        {{ routerSerial }}
                      </td>
                    </template>
                  </tr>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-layout>
        </v-container>
      </template>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "build-info",
  data () {
    return {
      error: false,
      expandBsSerial: -1,
      expandLNASerial: -1,
      expandUSBSerial: -1,
      expandRouterSerial: -1,
      loading: false,
      site: {
        bsSerials: [],
        connectionType: null,
        lnaSerials: [],
        mountType: null,
        routerSerials: [],
        stationInstallation: null,
        usbSerials: []
      }
    };
  },
  created () {
    this.loading = true;
    this.$http.
      get(`/api/sites/${this.$route.params.id}/build`).
      then((r) => this.site = r.data).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/BuildInfo.vue